
<template>
    <section class="content">
        <div class="container-fluid">
            <loader v-if="loading" :type="'table'"/>
            <div v-else>
                <div class="row">
                    <div class="col-12">
                    <h1>{{translate('messages.support_form')}}</h1>
                    <p>{{translate('messages.support_form_message')}}</p>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-12">
                        <div v-if="sent" class="alert alert-success alert-dismissible">
                            <button type="button" class="close" data-dismiss="alert" aria-hidden="true"><i class="fas fa-times"></i></button>
                            <h5><i class="icon fas fa-check"></i> {{translate('messages.email_sent')}}</h5>
                            {{translate('messages.support_sent')}}
                        </div>
                        <div class="card">
                            <div class="card-body">
                                <form @submit.prevent="sendSupportEmail" class="form-horizontal">
                                    <div class="form-group">
                                        <label for="inputName">{{translate('messages.name')}}</label>
                                        <input type="" v-model="form.name" class="form-control" id="inputName" :placeholder="translate('messages.name')" :class="{ 'is-invalid': form.errors.has('name') }">
                                        <has-error :form="form" field="name"></has-error>
                                        
                                    </div>
                                    <div class="form-group">
                                        <label for="inputEmail">{{translate('messages.email')}}</label>
                                            <input type="email" v-model="form.email" class="form-control" id="inputEmail" :placeholder="translate('messages.email')"  :class="{ 'is-invalid': form.errors.has('email') }">
                                            <has-error :form="form" field="email"></has-error>
                                    </div>
                                    <div class="form-group">
                                        <label for="inputMobilePhone">{{translate('messages.mobile_phone')}}</label>   
                                            <input type="text" v-model="form.mobile_phone" class="form-control" id="inputMobilePhone" :placeholder="translate('messages.mobile_phone')"  :class="{ 'is-invalid': form.errors.has('mobile_phone') }">
                                            <has-error :form="form" field="mobile_phone"></has-error>
                                    </div>
                                    <div class="form-group">
                                        <label for="inputSupportSubject">{{translate('messages.support_subject')}}</label>   
                                            <input type="text" v-model="form.support_subject" class="form-control" id="inputSupportSubject" :placeholder="translate('messages.support_subject')"  :class="{ 'is-invalid': form.errors.has('support_subject') }">
                                            <has-error :form="form" field="support_subject"></has-error>
                                    </div>
                                    <div class="form-group">
                                        <label for="inputProblemDescription">{{translate('messages.problem_description')}}</label>   
                                            <textarea rows="8" v-model="form.problem_description" class="form-control" id="inputProblemDescription" :placeholder="translate('messages.problem_description')"  :class="{ 'is-invalid': form.errors.has('problem_description') }"></textarea>
                                            <has-error :form="form" field="problem_description"></has-error>
                                    </div>
                                    <div class="form-group">
                                        <file-pond
                                        name="test"
                                        ref="supportPond"
                                        :label-idle="translate('messages.drop_add_images')"
                                        allow-multiple="true"
                                        accepted-file-types="image/jpeg, image/png"
                                        max-files="3"
                                        allowImageResize="true"
                                        imageResizeUpscale="false"
                                        imageResizeTargetWidth="1000"
                                        allowFileEncode="true"
                                        allowImageTransform="true"
                                        />
                                    </div>
                                    
                                    
                                    <div class="form-group">
                                        
                                        <button type="submit" class="btn btn-success">{{translate('messages.send')}}</button>
                                    
                                    </div>
                                </form>
                            </div><!-- /.card-body -->
                        </div>
                        <!-- /.nav-tabs-custom -->
                    </div>
                    <!-- end tabs -->
                </div>
            </div>
        </div>
    </section>
</template>

<script>
    // Import Vue FilePond
    import vueFilePond from "vue-filepond";

    // Import FilePond styles
    import "filepond/dist/filepond.min.css";

    // Import FilePond plugins
    // Please note that you need to install these plugins separately

    // Import image preview plugin styles
    import "filepond-plugin-image-preview/dist/filepond-plugin-image-preview.min.css";

    // Import image preview and file type validation plugins
    import FilePondPluginFileValidateType from "filepond-plugin-file-validate-type";
    import FilePondPluginImagePreview from "filepond-plugin-image-preview";
    import FilePondPluginImageResize from 'filepond-plugin-image-resize';
    import FilePondPluginFileEncode from 'filepond-plugin-file-encode';
    import FilePondPluginImageTransform from 'filepond-plugin-image-transform';

    // Create component
    const FilePond = vueFilePond(
    FilePondPluginFileValidateType,
    FilePondPluginImagePreview,
    FilePondPluginImageResize,
    FilePondPluginFileEncode,
    FilePondPluginImageTransform
    );

    export default {
        data(){
            return {
                 form: new Form({
                    id:'',
                    name : '',
                    email: '',
                    mobile_phone: '',
                    support_subject: '',
                    problem_description: '',
                    images:[]
                }),
                loading : true,
                sent : false
            }
        },
        mounted() {
            
        },
        components: {
            FilePond
        },
        methods:{
            loadProfile(){
                axios.get("api/profile")
                .then(({ data }) => {
                    this.form.fill(data.data);
                    
                    this.loading = false;
                });
            },
            sendSupportEmail(){
                this.$Progress.start();
                this.sent = false;
                this.form.update({images:[]});
                this.$refs.supportPond.getFiles().forEach((element, index) => {
                    this.form.images.push(element.getFileEncodeDataURL());
                    if(index>2) return;
                });
               
                
                this.form.post('api/profile/sendSupportEmail')
                .then((data)=>{
                    this.$Progress.finish();
                    Toast.fire({
                        icon: 'success',
                        title: data.data.message
                    });
                    this.form.reset();
                    this.sent = true;
                    this.$refs.supportPond.removeFiles();
                })
                .catch((error) => {
                    let error_obj = JSON.parse(error.request.response);
                    let error_title = typeof(error_obj.message) !== null && error.request.status < 500 ? error_obj.message : window.translate('messages.error_ocurred');
                    if(error_title=='The given data was invalid.') error_title = window.translate('messages.invalid_data');
                    Toast.fire({
                        icon: 'error',
                        title: error_title
                    });
                    this.$Progress.fail();
                });
            }
            
        },
        created() {
            this.loadProfile();
        }
    }
</script>
